import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { ToastProvider } from '@/components/ui/Toast'

export const Layout: React.FC = () => {
  const [collapsed,   setCollapsed]   = useState(false)
  const [mobileOpen,  setMobileOpen]  = useState(false)

  return (
    <ToastProvider>
      {/* Skip to main content for keyboard users */}
      <a href="#main-content" className="skip-link">
        Ana içeriğe geç
      </a>

      <div className="min-h-dvh bg-surface-muted dark:bg-slate-950">
        {/* Sidebar */}
        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />

        {/* Main column */}
        <div
          className={cn(
            'transition-all duration-300',
            collapsed ? 'lg:pl-[72px]' : 'lg:pl-[260px]',
          )}
        >
          {/* Header */}
          <Header
            collapsed={collapsed}
            onToggleCollapse={() => setCollapsed((v) => !v)}
            onMobileMenuOpen={() => setMobileOpen(true)}
          />

          {/* Page content */}
          <main
            id="main-content"
            className="pt-16 min-h-dvh"
            tabIndex={-1}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </ToastProvider>
  )
}
